var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-noti"},_vm._l((_vm.listNotifications),function(item,index){return _c('div',{key:index,staticClass:"list-noti--item"},[_c('div',{class:{
        icon: true,
        system: item.content.data.type,
        timekeeping: !item.content.data.type,
      }},[_c('i',{class:{
          'icon24-VB_DaChoYKien': item.content.data.type,
          'icon24-LichSu': !item.content.data.type,
        }})]),_c('div',{staticClass:"content"},[_c('p',{staticClass:"message",attrs:{"title":item.content.message}},[_vm._v(_vm._s(item.content.message))]),_c('p',{staticClass:"created-time",attrs:{"title":_vm.formatDateTime(item.createdTime)}},[_vm._v("\n        "+_vm._s(_vm.formatDateTime(item.createdTime))+"\n      ")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }